
import './customerInvoices.scss';

import CustomerInvoiceDetailRows from './customerInvoiceDetailRows.js';
import CustomerInvoiceTransactions from './customerInvoiceTransactions.js';

import { TabPanel, Item } from 'devextreme-react/tab-panel';

import { useCallback  } from "react";



export default function CustomerInvoiceDetail(props) {


  const onTabSelectionChanged = useCallback((e) => {
    //notify("The button was clicked");
    ;
  }, []); 

 
  function renderDetailRowsTab() {
    return <CustomerInvoiceDetailRows myKey = {props.data.key} status = {props.data.data.statoId} />;
  }

  function renderTransactionsTab() {
    return <CustomerInvoiceTransactions myKey = {props.data.key} status = {props.data.data.statoId}  data = {props.data.data}/>;
  }

  return (

    <div>

      <div className="offer-title" align="left" > 
        <h2>Fattura n° {props.data.data.numeroDoc} del {props.data.data.strDataDoc} -  {props.data.data.fornitore}</h2>      
      </div>

      <TabPanel    
        onSelectionChanged={onTabSelectionChanged}
      >
        <Item title="Dettaglio" render={renderDetailRowsTab} />
        <Item title="Incassi"  render={renderTransactionsTab}/>
      </TabPanel>

    </div>  
   
  )
};